import React from "react";
import { AssistanceMenu } from "./assistance/AssistanceMenu";

export const NeedAssistance = () => <AssistanceMenu reasons={['switch','discount','techIssue','meetingWithCS','other']} />